import React, {useEffect} from 'react';
import Chip from '@material-ui/core/Chip';
import GetAppIcon from '@material-ui/icons/GetApp';
import {Table} from '../../../components';
import {connect} from 'react-redux';

function Invoices(props){
  let headCells=[
    { id: 'date', maxWidth:'100px', numeric: false, disablePadding: false, label: 'Date' },
    { id: 'purchases', maxWidth:'300px', style:{paddingLeft:'30px'}, main:true, numeric: false, disablePadding: true, label: 'Purchases' },
    { id: 'amount', maxWidth:'150px', right:true, numeric: false, disablePadding: false, label: 'Amount' },
    { id: 'credits', maxWidth:'150px', right:true, numeric: false, disablePadding: false, label: 'Credits' },
    { id: 'payment_method', maxWidth:'150px',  numeric: false, disablePadding: false, label: 'Payment method' },
    { id: 'discount', maxWidth:'150px', numeric:false, disablePadding: false, label: 'Discount'}
  ]

  let rows=[]

  if(props.invoices!=undefined){
    for(let i of props.invoices){
      let currency=(i.currency=='usd')?'$':(i.currency=='eur')?'€':(i.currency=='gbp')?'£':null;
      let method='card'; if(i.type!=undefined){if(i.type=='stripe_card'){method=i.card_funding+' '+method+' ('+i.card_brand+' '+i.card_country+')'}else if(i.type.includes('stripe')){method=i.type.replace(/stripe/gi, '').replace(/_/g, ' ');}}
      method=method.charAt(0).toUpperCase() + method.slice(1);
      if(i.currency=='CONVERSION'){method='Credit conversion'}
      let credits_array={'/images/logo.png':0}
      let special_service=undefined; if(i.prospect_safari_service!=undefined && props.workspace!=undefined){for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.id==i.prospect_safari_service.workspace_default_special_service_id){special_service=ss;}}}}

      //THIS SETS AN ARRAY OF CREDITS SO THAT IF THERE ARE DIFFERENT TYPES OF CREDITS THEY ALL GET LISTED TOGETHER.
      for(let pi of i.payment_items){let special_service=undefined; if(pi.prospect_safari_service!=undefined && props.workspace!=undefined){for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.id==pi.prospect_safari_service.workspace_default_special_service_id){special_service=ss;}}}}
        if(pi.amount<0 && pi.credits>0){pi.credits=-pi.credits;}
        let credits=pi.credits*pi.quantity;
        if(special_service==undefined){for(let cp of i.credit_purchases){if(cp.workspace_default_special_service_id!=null){for(let wd of props.workspace.defaults){for(let ss of wd.special_services){if(ss.id==cp.workspace_default_special_service_id){special_service=ss; credits=cp.amount;}}}}}}
        if(special_service!=undefined){if(credits_array[special_service.logo]==undefined){credits_array[special_service.logo]=0} credits_array[special_service.logo]+=credits;
        }else{credits_array['/images/logo.png']+=credits;}
      }
      //THIS IS IF THERE ARE NO PAYMENT ITEMS USE MAIN PAYMENT;
      //WOULD BE BEST IF WE ALWAYS HAD PAYMENT ITEMS
      let creds=0; for(let cp of i.credit_purchases){creds+=cp.amount;} if(i.payment_items.length==0){if(special_service!=undefined){if(credits_array[special_service.logo]==undefined){credits_array[special_service.logo]=0} credits_array[special_service.logo]+=creds;}else{credits_array['/images/logo.png']+=creds;}}
      let credits=<div>{Object.keys(credits_array).map(function(key){if(credits_array[key]==0){}else{return(<span style={{marginRight:'10px'}}><span><img src={key} style={{width:'13px', marginRight:'5px', marginBottom:'-2px'}}/></span><span>{credits_array[key]}</span></span>)}})}</div>

      let amount=currency+(i.amount_paid/100);
      //NEXT LINE SETS AMOUNT TO CREDITS IN CASE WE HAVE A CREDIT CONVERSION. IT ONLY SHOWS THE FIRST CREDIT PURCHASE FOR NOW
      if(i.currency=='CONVERSION' && i.payment_with_credits!=undefined && i.payment_with_credits[0]!=undefined){amount=<div><span><img src='/images/logo.png' style={{width:'13px', marginRight:'5px', marginBottom:'-2px'}}/></span><span>{i.payment_with_credits[0].credits}</span></div>}
      let invoice_name=(i.prospect_safari_service==undefined)?'':i.prospect_safari_service.name+' - ';
      if(i.currency=='CONVERSION'){invoice_name='JumpStart Credits';}
      for(let pi of i.payment_items){if(pi.amount>=0){invoice_name+=pi.quantity+'x'+pi.prospect_safari_service.name+' - ';}}
      rows.push({purchases:<span><a href={'/api/invoices/'+i.id}>{invoice_name}</a></span>, credits:credits, amount:amount, date:i.created_at.split('T')[0], payment_method:method, discount:(i.stripe_discount==null)?'':i.stripe_discount.name})
    }
  }

  useEffect(()=>{
    props.indexInvoices();
  },[]);
  let balance=0;
  if(props.me.stripe_user!=undefined && props.me.stripe_user!=null){
    let balance=props.me.stripe_user.balance/100;
    if(props.workspace_data.test==true){balance=props.me.stripe_user.test_balance/100;}
  }
  return(
    <div style={{width:'100%', marginTop:'110px', position:'relative'}}>
      <div style={{position:'absolute', top:'-35px'}}><Chip size='small' variant='outlined' color='secondary' icon='$' inputLabelProps={{shrink:true}} label={'Current balance: $ '+balance}/></div>
      <Table {...props} main='name' title='Payments' rows={rows} total={rows.length} headers={headCells}/>
    </div>
  )
}


function Single_chip(props){
  const classes=useStyles(props)
  const handleDelete = key => () => {let new_value=[]; let i=0; for(let x of props.fields.value){if(i!=key){new_value.push(x);} i+=1;}; props.fields.remove(key); props.onDelete(); props.onUpdate(new_value);};
  return(
  <Chip
    size='small'
    variant='outlined'
    color='primary'
    key={props.value.js_id}
    icon={props.icon}
    inputLabelProps={{shrink:true}}
    label={props.value[props.value_name]}
    onDelete={handleDelete(props.index_id)}
    onClick={(e)=>{props.onClick(props.index_id, props.value[props.value_name])}}
    deleteIcon={<CancelIcon color='secondary' style={{width:'12px', height:'12px'}}/>}
    className={classes.chip}
  />
  )
}


export default connect(ss, dd)(Invoices);

function ss(state){
  return{
    invoices:state.payments.invoices,
    rerender:state.payments.rerender
  }
}

function dd(dispatch){
  return{
    indexInvoices:()=>{dispatch({type:'REQUEST_INDEX_INVOICES'})}
  }
}
